import { render, staticRenderFns } from "./mobileGaokao.vue?vue&type=template&id=1bf9d215&scoped=true&"
import script from "./mobileGaokao.vue?vue&type=script&lang=js&"
export * from "./mobileGaokao.vue?vue&type=script&lang=js&"
import style0 from "./mobileGaokao.vue?vue&type=style&index=0&id=1bf9d215&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9d215",
  null
  
)

export default component.exports